import { FieldTypes } from '../../components/FormBuilder';
import {
  CommonDetails
} from '../../constants';

export const formInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  msisdn: '',
  privacyConsent: false
};
export const firstName = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Name',
  name: 'firstName',
  disabled: false,
  dark: false,
  hideUnderline: true,
  hint: 'As it appears on your ID or Passport'
};
export const lastName = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Surname',
  name: 'lastName',
  disabled: false,
  dark: false,
  hideUnderline: true,
  hint: 'As it appears on your ID or Passport'
};
export const email = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Email address',
  name: 'email',
  disabled: false,
  dark: false,
  hideUnderline: true
};
export const msisdn = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Cell number',
  name: 'msisdn',
  disabled: false,
  dark: false,
  hideUnderline: true,
  hint: 'We will send a verification to this number'
};

export const privacyConsent = {
  name: 'privacyConsent',
  checkboxlabel: 'I agree to the processing of my data by Vodacom Payment Services and related third parties as outlined in the Vodacom Privacy Statement',
  variant: 'secondary',
  size: 'md',
  shape: 'square',
  disabled: false,
  link: 'Vodacom Privacy Statement',
  linkurl: CommonDetails.vodalendPrivacyPolicy
};

export const formFields = [
  {
    type: FieldTypes.INPUT,
    props: firstName
  },
  {
    type: FieldTypes.INPUT,
    props: lastName
  },
  {
    type: FieldTypes.INPUT,
    props: msisdn
  },
  {
    type: FieldTypes.INPUT,
    props: email
  },
  {
    type: FieldTypes.CHECKBOX,
    props: privacyConsent
  }
];